import { FilePdfOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { Package } from 'models/Waybill';
import { useState } from 'react';
import { WaybillViewer } from './WaybillViewer';

interface ViewWaybillsButtonProps {
  packagesWithWaybill: Package[];
  sparingRequestName: string;
}

export const ViewWaybillsButton: React.FC<ViewWaybillsButtonProps> = ({ packagesWithWaybill, sparingRequestName }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button onClick={() => setIsOpen(true)} icon={<FilePdfOutlined />}>
        View Waybills
      </Button>
      <WaybillViewer packagesWithWaybill={packagesWithWaybill} sparingRequestName={sparingRequestName} open={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};
